import React from 'react';
import PropTypes from 'prop-types';

import {
  FirstNameInput,
  Label,
  LastNameInput,
  PhoneInput,
  EmailInput,
  TranslationProvider,
} from '@resy/ui-kitchen';

import './GuestInfoInput.scss';

class GuestInfoInput extends React.Component {
  // TODO(CON-17456): Align concierge phone entry validation and decoration lifecycle
  // with SmsView/UpdatePhone (libphonenumber-js checks + clear-on-edit behavior).
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    errors: PropTypes.arrayOf(PropTypes.string),
    countryCodes: PropTypes.arrayOf(PropTypes.shape({
      iso3166: PropTypes.string,
      code: PropTypes.string,
      country_name: PropTypes.string,
    })),
    defaultCountryCode: PropTypes.string,
    info: PropTypes.shape({
      country_code: PropTypes.string,
      email: PropTypes.string,
      first_name: PropTypes.string,
      last_name: PropTypes.string,
      phone: PropTypes.string,
    }),
  };

  static defaultProps = {
    errors: [],
    countryCodes: undefined,
    defaultCountryCode: '1',
    info: undefined,
  };

  state = {}

  handleChange = (value) => {
    const { onChange } = this.props;
    this.setState((state) => ({
      ...state,
      ...value,
    }), () => {
      onChange(this.state);
    });
  }

  render() {
    const {
      countryCodes,
      errors,
      defaultCountryCode,
      info,
    } = this.props;

    const {
      country_code: countryCode,
      email,
      first_name: firstName,
      last_name: lastName,
      phone,
    } = info || {};

    return (
      <div className="GuestInfoInput">
        <div className="GuestInfoInput__name">
          <div>
            <Label forInput="first_name" required>
              <TranslationProvider
                translationKey="first_name"
              >
                <span>First Name</span>
              </TranslationProvider>
            </Label>
            <FirstNameInput value={firstName} onChange={this.handleChange} errors={errors} />
          </div>
          <div>
            <Label forInput="last_name" required>
              <TranslationProvider
                translationKey="last_name"
              >
                <span>Last Name</span>
              </TranslationProvider>
            </Label>
            <LastNameInput value={lastName} onChange={this.handleChange} errors={errors} />
          </div>
        </div>
        <Label forInput="phone" required>
          <TranslationProvider
            translationKey="mobile_phone"
          >
            <span>Mobile Phone</span>
          </TranslationProvider>
        </Label>
        <PhoneInput
          defaultCountryCode={countryCode || defaultCountryCode}
          errors={errors}
          countryCodes={countryCodes}
          onChange={this.handleChange}
          phone={phone}
          preferParentChangeHandler
        />
        <Label forInput="email" required>
          <TranslationProvider
            translationKey="email"
          >
            <span>Email Address</span>
          </TranslationProvider>
        </Label>
        <EmailInput value={email} onChange={this.handleChange} errors={errors} />
      </div>
    );
  }
}

GuestInfoInput.displayName = 'GuestInfoInput';
export default GuestInfoInput;
